import React from "react";

export default function NoMatchPage() {
	return (
		<div>
			<h1>404 - PAGE NOT FOUND</h1>
		</div>
	);
}
